export default {
  "fontElementMap": "_2mh2Y",
  "orderedlist": "FMUQy",
  "bulletedlist": "nJTk1",
  "listItem": "PqxAp"
};